module.exports = __webpack_public_path__ + "static/media/email-inactive.f6539b14.svg";